export default {
  columns: 12, // grid columns count
  rowHeight: 50, // grid row height (incl. bottom padding)
  margins: 15, // widget margins
  mobileBreakPoint: 800,
  // defaults for widgets
  defaultSizeX: 6,
  defaultSizeY: 3,
  minSizeX: 2,
  maxSizeX: 12,
  minSizeY: 2,
  maxSizeY: 1000,
};
